import script from "./ViewCommentsMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewCommentsMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./ViewCommentsMolecule.css?vue&type=style&index=0&id=45ce947f&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ce947f"]])

export default __exports__